import Vue from 'vue'
import Vuex, { mapState } from 'vuex'
import { Slide } from 'vue-carousel'
import slugify from 'slugify'
import once from 'lodash/once'
import get from 'lodash/get'

import Carousel from '../../components/core/Carousel'
import ItineraryList from '../../views/yacht/ItineraryList'
import Cabins from '../../views/yacht/Cabins'
import YachtIntro from '../../views/yacht/YachtIntro'
import YachtSidebar from '../../views/yacht/YachtSidebar'
import BoatFacilities from '../../views/yacht/BoatFacilities'
import DiveCenterFacilities from '../../views/yacht/DiveCenterFacilities'

import ZbModal from '../../components/core/ZbModal'
import FooterNav from '../../components/Liveaboard/FooterNav'
import Responsive from '../../components/core/Responsive'
import FeaturedReview from '../../components/FeaturedReview'
import CurrencyContext from '../../components/core/CurrencyContext'

Vue.use(Vuex)
Vue.filter('formatPrice', (rawPrice) => {
  return rawPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
})
Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('itinerary-list', ItineraryList)
Vue.component('cabins', Cabins)
Vue.component('yacht-intro', YachtIntro)
Vue.component('yacht-sidebar', YachtSidebar)
Vue.component('boat-facilities', BoatFacilities)
Vue.component('dive-center-facilities', DiveCenterFacilities)
Vue.component('zb-modal', ZbModal)
Vue.component('footer-nav', FooterNav)
Vue.component('responsive', Responsive)
Vue.component('featured-review', FeaturedReview)
Vue.component('currency-context', CurrencyContext)

window.fetchSupplierInfo = once((supplierId) => {
  return new Promise((resolve, reject) => {
    $.get(`${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${supplierId}`)
      .done(res => {
        if (res === 'No Supplier Found') {
          reject()
        }
        else {
          resolve(res)
        }
      })
      .fail(reject)
  })
})

$(document).ready(function() {
  initStickyNav()
})

// TODO: remove if dont use
function initStickyNav () {
  const stickyHeader = $('.resort-nav')

  const h2s = Array.from(document.querySelectorAll('h2[data-sticky-nav-item]'))
  const list = stickyHeader.find('ul')

  let index = 0
  for (const h2 of h2s) {
    const slug = slugify(h2.textContent)
    h2.id = slug

    let hiddenClass = ''

    if (h2.classList.contains('data-sticky-nav-item-hidden')) {
      hiddenClass = 'hidden'
    }

    list.append(`
      <li class="h-full mb-0">
        <a href="#${slug}" class="resort-nav-link outline-none font-medium ${hiddenClass} ${index === 0 ? 'active' : ''}">
          ${h2.textContent.trim()}
        </a>
      </li>
    `)

    index++
  }

  stickyHeader.stickySidebar({
    topSpacing: 0,
    bottomSpacing: 0,
    containerSelector: '.sticky-nav-container',
    innerWrapperSelector: '.sidebar__inner'
  })

  stickyHeader.get(0).addEventListener('affixed.top.stickySidebar', function () {
    $('.resort-nav').addClass('resort-nav--show')
  })

  stickyHeader.get(0).addEventListener('affix.static.stickySidebar', function () {
    $('.resort-nav').removeClass('resort-nav--show')
  })

  $('.resort-nav').navpoints()

  $('.plan-trip-btn').click(() => {
    window.scrollToElement($('h2#Itineraries'))
  })
}

const store = new Vuex.Store({
  state() {
    return {
      supplier: null,
    }
  },
  getters: {
    supplier(state) {
      return get(state.supplier, 'supplier', {})
    },
    cabinLabel(state, getters) {
      return getters.supplier.number_of_cabins > 1 ? "cabins" : "cabin";
    },
    guestLabel(state, getters) {
      return getters.supplier.max_occupancy > 1 ? "guests" : 'guest'
    }
  },
  mutations: {
    setSupplier (state, supplier) {
      state.supplier = supplier
    }
  },
  actions: {
    fetchSupplierInfo () {
      window.fetchSupplierInfo(window.zubluSupplierId)
        .then(response => {
          store.commit('setSupplier', response)
        })
    }
  }
})

store.dispatch('fetchSupplierInfo')

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML,
  store
}))
